import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"font-weight":"bold","font-size":"16pt"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = {
  key: 0,
  style: {"font-weight":"ligther","font-size":"8pt","color":"#f9b12a"}
}
const _hoisted_12 = {
  key: 1,
  style: {"font-weight":"ligther","font-size":"8pt","color":"#f9b12a"}
}
const _hoisted_13 = {
  key: 2,
  style: {"font-weight":"ligther","font-size":"8pt","color":"green"}
}
const _hoisted_14 = { class: "d-flex align-center primary--text" }
const _hoisted_15 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip_tag = _resolveComponent("v-chip-tag")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_ctx.items.length)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        "no-gutters": "",
        class: "d-flex justify-center",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow-y:auto')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: item.id,
              cols: _ctx.$vuetify.display.mobile ? '12' : '8'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "default_card",
                  "pa-0": "",
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      class: "d-flex align-center",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('to-route', item)), ["stop"]),
                      style: {"cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: _ctx.getIcon(item),
                              color: "green",
                              size: "x-large",
                              onClick: _withModifiers(($event: any) => (_ctx.$emit('icon-click', item)), ["stop"])
                            }, null, 8, ["icon", "onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getTitle(item)), 1),
                            (_ctx.getAction(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    class: "mr-2",
                                    icon: "$fa-edit",
                                    color: "secondary"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.getAction(item)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getWording(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    class: "mr-2",
                                    icon: "$label",
                                    color: "secondary"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.getWording(item)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.hideTargets)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (_ctx.allTargets)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTargets(item), (value, key) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                            value
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    class: "mr-2",
                                                    icon: _ctx.iconMapping[key],
                                                    color: "secondary"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString(value), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createVNode(_component_v_icon, {
                                          icon: "$fa-bullseye",
                                          size: "x-small",
                                          class: "mr-2"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getTargets(item)), 1)
                                      ]))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.companyScope && !_ctx.hideStatus)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (
                                        item.companyScope.accountingCompanyOwner &&
                                        item.companyScope.accountingCompanyOwner.name !== 'OSS360'
                                    )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString("Créé par " + item.companyScope.accountingCompanyOwner.name), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_9, " Proposé par bobbee "))
                                ]))
                              : _createCommentVNode("", true),
                            (item.companyScope && !_ctx.hideStatus)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  (
                                        item.companyScope.scopeSharingStatus ===
                                            'PENDING_VALIDATION' && _ctx.isRootProfile
                                    )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Partage à valider"))
                                    : (
                                        item.companyScope.scopeSharingStatus ===
                                            'PENDING_VALIDATION' && !_ctx.isRootProfile
                                    )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Partage en attente de validation"))
                                      : (
                                        item.companyScope.scopeSharingStatus === 'VALIDATE' &&
                                        !item.companyScope.accountingCompany
                                    )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Partage validé par bobbee"))
                                        : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getTags(item))
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.getTags(item), (tag, index) => {
                                  return (_openBlock(), _createBlock(_component_v_chip_tag, {
                                    key: 'tag-' + tag + index,
                                    class: "mr-1",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-space-around align-center"
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.hideEdition)
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 0,
                                  icon: _ctx.isReadonly(item.companyScope) ? '$oss-eye' : '$oss-edit',
                                  elevation: "0",
                                  size: "small",
                                  density: "compact",
                                  onClick: _withModifiers(($event: any) => (_ctx.$emit('to-route', item)), ["stop"])
                                }, null, 8, ["icon", "onClick"]))
                              : _createCommentVNode("", true),
                            (!_ctx.hideDuplication)
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 1,
                                  icon: "$oss-duplicate",
                                  elevation: "0",
                                  size: "small",
                                  density: "compact",
                                  onClick: _withModifiers(($event: any) => (_ctx.$emit('duplicate', item)), ["stop"])
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!_ctx.hideDeletion && _ctx.enableItemDeletion(item.companyScope))
                              ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                  key: 2,
                                  size: "small",
                                  density: "compact",
                                  onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', item)), ["stop"])
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (item.id === _ctx.toExpandId)
                      ? (_openBlock(), _createBlock(_component_v_expand_transition, { key: 0 }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(_component_v_divider),
                              _renderSlot(_ctx.$slots, "default", { previewItem: item })
                            ], 512), [
                              [_vShow, _ctx.showPreview]
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["cols"]))
          }), 128)),
          (!_ctx.hideIntersection)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.patternCount > _ctx.items.length)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "8"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "default_card",
                          elevation: "0",
                          "pa-0": "",
                          style: {"margin":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_skeleton_loader, { type: "avatar" })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "9" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_skeleton_loader, {
                                      type: "heading",
                                      class: "my-3"
                                    }),
                                    _createVNode(_component_v_skeleton_loader, {
                                      type: "text",
                                      class: "my-auto"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_intersect, _ctx.onIntersectNext]
                    ])
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["style"]))
    : (_openBlock(), _createBlock(_component_v_row, {
        key: 1,
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.$vuetify.display.mobile ? '12' : '6',
            class: "my-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card ma-0",
                elevation: "0",
                "pa-0": "",
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      (!_ctx.$vuetify.display.mobile)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "2",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: _ctx.getIcon({}),
                                color: "new_red",
                                class: "icon",
                                size: "x-large"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, {
                        cols: _ctx.$vuetify.display.mobile ? '10' : '8'
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                              style: {"font-weight":"bold","font-size":"16pt"}
                            }, _toDisplayString(_ctx.parameters.emptyTitle), 3)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                            }, _toDisplayString(_ctx.parameters.emptyMessage), 3)
                          ])
                        ]),
                        _: 1
                      }, 8, ["cols"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }))
}